import { useEffect, useState } from "react";
import { Col, Input, Row, Select } from "antd";
import {
  modTypes,
  interactiveGotoTypes,
  IInteractiveModGoto,
  getPath,
  COMMON_PATHS,
  findLayersOrLayerAssets,
} from "@blings/blings-player";
import { ModsPanelCompProps } from "../../ModsPanel";
import { DynamicValueMod, DynamicValueModTypes } from "../../DynamicValueMod";
import { AddInteractiveHOC } from "./InteractiveFormHOC";
import MainCTAButton from "../../../MainCTA/MainCTAButton";
import { InfoTooltip } from "../../../../BaseComps/InfoTooltip";
import { sharedInputAllowClear } from "../../../antd-extensions/selectClearIcon";

export enum interactiveActionTypes {
  jumpToFrame = "jumpToFrame",
  jumpToMarker = "jumpToMarker",
}

function RenderGoToOptions(props: ModsPanelCompProps<IInteractiveModGoto>) {
  const { change, json, onChange, index } = props;
  const [actionState, setActionState] = useState<
    interactiveActionTypes | undefined
  >(
    (() => {
      switch (change.type) {
        case modTypes.interactiveGoto:
          return (change as IInteractiveModGoto).gotoType ===
            interactiveGotoTypes.marker
            ? interactiveActionTypes.jumpToMarker
            : interactiveActionTypes.jumpToFrame;
      }
    })()
  );

  useEffect(() => {
    if (change.ctaName == null) {
      const layers = findLayersOrLayerAssets({
        assetId: change.assetId,
        layerName: change.layerName,
        layerUid: change.layerUid,
        jsonVid: json,
        additionals: change.additionals,
      });
      const layer =
        layers?.length &&
        layers.find((layer) => getPath(layer, COMMON_PATHS.TEXT_IN_LAYER));
      if (layer) {
        const text = getPath(layer, COMMON_PATHS.TEXT_IN_LAYER);
        text && onChange(index, "ctaName", text);
      }
    }
  }, [
    change.ctaName,
    change.assetId,
    change.layerName,
    change.layerUid,
    change.additionals,
    json,
    onChange,
    index,
  ]);

  function renderActionForm(props: ModsPanelCompProps<IInteractiveModGoto>) {
    switch (actionState) {
      case interactiveActionTypes.jumpToFrame:
        return (
          <div>
            <DynamicValueMod<modTypes.interactiveGoto>
              change={props.change}
              onChange={(index, keys, values) => {
                props.onChange(
                  index,
                  (keys as Array<keyof IInteractiveModGoto>).concat(
                    "type",
                    "gotoType"
                  ),
                  values.concat(
                    modTypes.interactiveGoto,
                    interactiveGotoTypes.frame
                  )
                );
              }}
              index={props.index}
              modId={props.modId}
              type={DynamicValueModTypes.number}
              modT={modTypes.interactiveGoto}
            />
          </div>
        );
      case interactiveActionTypes.jumpToMarker:
        return (
          <Select
            style={{ width: "100%" }}
            options={props.json?.markers.map((m) => ({
              label: m.cm,
              value: m.cm,
            }))}
            onChange={(v) => {
              props.onChange(
                props.index,
                ["value", "type", "gotoType"],
                [v, modTypes.interactiveGoto, interactiveGotoTypes.marker]
              );
            }}
          />
        );
      default:
        return;
    }
  }

  return (
    <>
      <Row>
        <Col style={{ width: "100%" }}>
          <span style={{ color: "#6E7079", lineHeight: "22px" }}>
            Name this button (Required for analytics)
          </span>
          <InfoTooltip
            style={{ marginLeft: "5px" }}
            info="This name is used to track how many viewers clicked on the button."
          />
          <Input
            style={{ width: "100%", marginTop: "4px" }}
            id="connector-cta-name"
            value={props.change.ctaName}
            // eslint-disable-next-line no-template-curly-in-string
            placeholder="Name this button"
            onChange={(e) =>
              props.onChange(props.index, ["ctaName"], [e.target.value])
            }
            allowClear={sharedInputAllowClear}
          />
        </Col>
      </Row>
      <Select<interactiveActionTypes>
        placeholder="Select action"
        style={{ width: "100%" }}
        onChange={(v) => {
          setActionState(v);
          return props.onChange(
            props.index,
            [
              "dataKey",
              "value",
              "expression",
              "liveControlKey",
              "inputName",
              "defaultValue",
            ],
            []
          );

          // props.onChange(props.index, "event", v);
        }}
        options={[
          { label: "Jump To Frame", value: interactiveActionTypes.jumpToFrame },
          {
            label: "Jump To Marker",
            value: interactiveActionTypes.jumpToMarker,
          },
        ]} //.map(e => ({label: e, value: e}))}
        value={actionState}
      />
      {renderActionForm(props)}
      <MainCTAButton
        change={props.change}
        onChange={props.onChange}
        index={props.index}
      />
    </>
  );
}

export function AddInteractiveGotoForm(
  props: ModsPanelCompProps<IInteractiveModGoto>
) {
  return (
    <AddInteractiveHOC<IInteractiveModGoto>
      {...props}
      renderSpecificInteractive={RenderGoToOptions}
    />
  );
}
